// 设计师相关
const DrawingUpload = () => import('@/pages/personalCenter/designPage/drawingUpload.vue')
const TodoList = () => import('@/pages/personalCenter/designPage/todoList.vue')
const DesignDetails = () => import('@/pages/personalCenter/designPage/designDetails.vue')
const DesignProcess = () => import('@/pages/personalCenter/designPage/designProcess.vue')
const ViewDrawing = () => import('@/pages/personalCenter/designPage/viewDrawing.vue')

export default [
  {
    path: '/personalCenter/designPage/drawingUpload',
    name: '图纸上传',
    component: DrawingUpload,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/designPage/todoList',
    name: '我的待办',
    component: TodoList,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/designPage/designDetails',
    name: '设计详情',
    component: DesignDetails,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/designPage/designProcess',
    name: '设计进程',
    component: DesignProcess,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/designPage/viewDrawing',
    name: '查看图纸',
    component: ViewDrawing,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/designRouter.js